














































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CheckGradientIcon extends Vue {
  @Prop({ default: '96' }) readonly width?: string;
  @Prop({ default: '96' }) readonly height?: string;
}
